export default __webpack_public_path__ + "static/media/defaultimg.72de0eda.jpg";